import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { connect } from 'react-redux'
import {
  Btn,
  CustomDropdown,
  CustomModal,
  HeaderText,
  InputNumeroDecimal,
  InputNumeroInteiro,
} from '../../../../../components'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { showMessageBox } from '../../../../../store/actions/system.actions'

import { Dropdown } from 'primereact/dropdown'
import * as RetornoHttp from '../../../../../services/api/https/deliveries/retorno.http'
import { errorHandler } from '../../../../../services/util/error.service'
import { getEmpresas } from '../../../../../services/localstorage/localstorage.service'
import {
  buildSobraQuantityInputState,
  getSobraInputLabels,
  getSobraQuantityConfig,
  getSobraQuantityValueFromInputs,
} from './sobra-volume-and-units.helper'

const INITIAL_STATE = {
  errorMessage: null,
  globalFilter: '',
  produtos: [],
  reasons: [],
  selectedCompany: null,
  companies: getEmpresas(),
}

function formatProduct(product) {
  const quantityState = buildSobraQuantityInputState(product, '')

  return {
    ...product,
    missing_reason: null,
    qte_leftover: quantityState.quantityValue,
    qte_leftover_volume: quantityState.volumeValue,
    qte_leftover_units: quantityState.unitsValue,
  }
}

function ModalNovaSobra({
  dispatch,

  fleetId,
  onSuccess,
  onModalClose,
  onError,
  visible,
  vehicleBadge,
}) {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    async function fetchData() {
      try {
        const { products, missing_reasons } = await RetornoHttp.getLeftoverProductInfoByCompanyId(
          state.selectedCompany.id,
        )
        setState(prevState => ({
          ...prevState,
          produtos: products.map(formatProduct),
          reasons: missing_reasons,
        }))
      } catch (err) {
        setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) }))
      }
    }
    if (state.selectedCompany) fetchData()
  }, [state.selectedCompany])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(INITIAL_STATE)
    }
  }, [state.errorMessage])

  function onGlobalFilterChange(value) {
    setState(prevState => ({ ...prevState, globalFilter: value }))
  }

  function onFormContentChange(item, name, value) {
    setState(prevState => ({
      ...prevState,
      produtos: prevState.produtos.map(produto => {
        if (produto.id !== item.id) {
          return produto
        }

        if (name === 'missing_reason') {
          return { ...produto, missing_reason: value }
        }

        if (name === 'qte_leftover_volume' || name === 'qte_leftover_units') {
          const nextProduct = {
            ...produto,
            [name]: value,
          }

          return {
            ...nextProduct,
            qte_leftover: getSobraQuantityValueFromInputs(
              nextProduct,
              nextProduct.qte_leftover_volume,
              nextProduct.qte_leftover_units,
            ),
          }
        }

        return produto
      }),
    }))
  }

  const onBtnSalvarClicked = async () => {
    try {
      const info = []

      for (let i = 0; i < state.produtos.length; i++) {
        const p = state.produtos[i]
        const hasReason = Boolean(p.missing_reason)
        const hasQuantity = p.qte_leftover !== '' && Number(p.qte_leftover) > 0

        if (!hasReason && hasQuantity) {
          throw new Error('Selecione um motivo para a ocorrência')
        }

        if (hasReason && !hasQuantity) {
          throw new Error('Selecione a qte apurado para a ocorrência')
        }

        if (hasQuantity && hasReason) {
          info.push({
            product_id: p.id,
            fleet_id: fleetId,
            missing_reason_id: p.missing_reason.id,
            qte_leftover: Number(p.qte_leftover),
          })
        }
      }

      await RetornoHttp.postLeftoverProducts(info)

      onSuccess()
    } catch (e) {
      onError(e)
    }
  }

  const header = (
    <div style={{ textAlign: 'left' }}>
      <i className="pi pi-search" style={{ margin: '0px 4px 0px 10px' }}></i>
      <InputText
        value={state.globalFilter}
        onChange={e => onGlobalFilterChange(e.target.value)}
        placeholder="Pesquisar . . ."
        size="50"
      />
    </div>
  )

  const renderQuantityInput = (item, field) => {
    const { canUseFractionedInput } = getSobraQuantityConfig(item)
    const { volumeLabel, unitsLabel } = getSobraInputLabels(item)
    const isVolumeField = field === 'qte_leftover_volume'
    const label = isVolumeField ? volumeLabel : unitsLabel
    const isCustomLabel = label !== (isVolumeField ? 'Vol.' : 'Frac.')

    return (
      <div style={{ minWidth: 80 }}>
        {isCustomLabel ? (
          <div
            style={{
              fontSize: '0.72rem',
              color: '#666',
              fontWeight: 600,
              textAlign: 'center',
              marginBottom: 4,
            }}
          >
            {label}
          </div>
        ) : null}
        {isVolumeField ? (
          canUseFractionedInput ? (
            <InputNumeroInteiro
              marginTop={0}
              value={item.qte_leftover_volume}
              onChange={value => onFormContentChange(item, field, value)}
              width={80}
              allowNegative={false}
            />
          ) : (
            <InputNumeroDecimal
              marginTop={0}
              showLabel={false}
              value={item.qte_leftover_volume}
              onChange={value => onFormContentChange(item, field, value)}
              width={80}
            />
          )
        ) : (
          <InputNumeroInteiro
            marginTop={0}
            value={item.qte_leftover_units}
            onChange={value => onFormContentChange(item, field, value)}
            width={80}
            disabled={!canUseFractionedInput}
            allowNegative={false}
          />
        )}
      </div>
    )
  }

  return (
    <CustomModal
      header="Nova Ocorrência de Sobra"
      isVisible={visible}
      onClose={onModalClose}
      width={'90%'}
      style={{ maxWidth: '95vw' }}
      contentStyle={{ maxHeight: '80vh', overflowY: 'auto' }}
    >
      <HeaderText>
        <div style={{ display: 'flex', gap: '10px' }}>
          <p style={{ padding: 0, margin: 0 }}>
            <strong>Veículo:</strong> {vehicleBadge}
          </p>
        </div>
      </HeaderText>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          gap: 16,
          flexWrap: 'wrap',
          padding: '16px 0 18px',
        }}
      >
        <div style={{ width: 440, maxWidth: '100%' }}>
          <CustomDropdown
            filter={true}
            optionLabel="name"
            options={state.companies}
            value={state.selectedCompany}
            label="Empresa :"
            onChange={value => setState(prevState => ({ ...prevState, selectedCompany: value }))}
          />
        </div>
        <div style={{ width: 120 }}>
          <Btn onClick={() => onBtnSalvarClicked()}>Salvar</Btn>
        </div>
      </div>
      <DataTable
        value={state.produtos}
        paginator={true}
        rows={10}
        header={header}
        globalFilter={state.globalFilter}
      >
        <Column field="product_code" header="Código" style={tableCellCentered()} />
        <Column field="name" header="Produto" />
        <Column
          header="Motivo"
          style={tableCellCentered(320)}
          body={sobra => {
            return (
              <Dropdown
                disabled={state.btnAssociarDisabled}
                style={{ width: '100%' }}
                optionLabel="name"
                value={sobra.missing_reason}
                options={state.reasons}
                onChange={({ value }) => onFormContentChange(sobra, 'missing_reason', value)}
                placeholder="Selecione o Motivo da Ocorrência"
              />
            )
          }}
        />
        <Column
          header="Vol."
          style={tableCellCentered(100)}
          body={produto => renderQuantityInput(produto, 'qte_leftover_volume')}
        />
        <Column
          header="Frac."
          style={tableCellCentered(100)}
          body={produto => renderQuantityInput(produto, 'qte_leftover_units')}
        />
      </DataTable>
    </CustomModal>
  )
}

const mapStateToProps = ({ picking: { selectedPicking } }) => ({ selectedPicking })
export default connect(mapStateToProps)(ModalNovaSobra)
